import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../api';

type Stage = 'alpha' | 'beta' | 'preview';

/**
 * The "Beta" badge beside the Fyr mark — shown only where the instance sets FYR_RELEASE_STAGE (dev.fyr.work, for
 * testers); prod sets nothing, so nothing renders. Reads the same public /auth/config the sign-in page uses (one
 * cached request, shared query key), so it works before sign-in too.
 */
export function ReleaseBadge() {
  const { t } = useTranslation();
  const cfg = useQuery({
    queryKey: ['auth-config'],
    queryFn: () => api.get<{ releaseStage?: Stage | null }>('/auth/config'),
    staleTime: Infinity,
  });
  const stage = cfg.data?.releaseStage;
  if (!stage) return null;
  return (
    <span className={`release-badge release-${stage}`} title={t(`release.${stage}Hint`)}>
      {t(`release.${stage}`)}
    </span>
  );
}
